import React, { useState, useEffect } from "react";
import { Menu, X, UploadCloud } from "lucide-react";

const LINKS = [
  { id: "orcamento", label: "Pedir Orçamento" },
  { id: "portfolio", label: "Portfólio" },
  { id: "materiais", label: "Materiais & Tech" },
  { id: "confidencialidade", label: "Confidencialidade" },
  { id: "faq", label: "FAQ" },
];

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => { setOpen(false); scrollTo(id); };

  return (
    <header
      data-testid="site-navbar"
      className={`sticky top-0 z-50 w-full backdrop-blur-xl bg-ax-bg/85 border-b transition-all duration-300 ${
        scrolled ? "border-ax-border shadow-lg shadow-black/40" : "border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <button data-testid="nav-logo" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="flex items-center gap-2.5 group">
          <span className="relative flex h-2.5 w-2.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-60" />
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-500" />
          </span>
          <span className="font-heading font-extrabold text-lg tracking-tight text-ax-text">
            Axio<span className="text-ax-orange">Form</span> 3D
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-1">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className="px-3.5 py-2 text-sm font-medium text-ax-sub hover:text-ax-text transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <button
            data-testid="nav-cta"
            onClick={() => go("orcamento")}
            className="inline-flex items-center gap-2 bg-ax-orange hover:bg-ax-orangehover text-white text-sm font-semibold px-4 py-2.5 rounded-lg transition-all hover:scale-[1.03] hover:ax-glow"
          >
            <UploadCloud className="w-4 h-4" /> Envie o seu Ficheiro 3D
          </button>
        </div>

        <button data-testid="nav-toggle" className="lg:hidden text-ax-text" onClick={() => setOpen(!open)}>
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-ax-surface border-t border-ax-border px-5 py-4 flex flex-col gap-1">
          {LINKS.map((l) => (
            <button key={l.id} data-testid={`nav-m-${l.id}`} onClick={() => go(l.id)} className="text-left py-2.5 text-ax-sub hover:text-ax-text">
              {l.label}
            </button>
          ))}
          <button onClick={() => go("orcamento")} className="mt-2 bg-ax-orange text-white font-semibold px-4 py-3 rounded-lg">
            Envie o seu Ficheiro 3D
          </button>
        </div>
      )}
    </header>
  );
};

export { scrollTo };
